export default __webpack_public_path__ + "static/media/success.ee29b094.svg";